export var noConflict = function noConflict() {
  if (window.$ && !window.$.fn) {
    window._$ = window.$;
    window.$ = void 0;
  }
};